import { createFileRoute } from '@tanstack/react-router';

import { PlansListPage } from '@/features/plans/PlansListPage';

export const Route = createFileRoute('/_app/plans/')({
  component: PlansListPage,
});
